export default __webpack_public_path__ + "assets/jpg/header.4a53037f6ce902ce7d69ad9666b30c87.jpg";